export default function ProductsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M7.5 10.7202H13.5M7.5 7.72021H13.5M4.5 0.970215V17.4702M1.5 0.970215H16.5C16.9142 0.970215 17.25 1.306 17.25 1.72021V16.7202C17.25 17.1344 16.9142 17.4702 16.5 17.4702H1.5C1.08579 17.4702 0.75 17.1344 0.75 16.7202V1.72021C0.75 1.306 1.08579 0.970215 1.5 0.970215Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
